import { Navigate, Route } from "react-router";
import React from "react";

/**
 * Gets redirect route definitions based on whether the user has companies.
 * Routes users to appropriate default pages based on their account state.
 *
 * @param hasCompanies - Whether the user has any associated companies
 * @returns Array of Route elements with appropriate redirects
 */
export const redirectRoutes = (
  hasCompanies: boolean,
): React.ReactElement<any>[] => {
  const returnArray: React.ReactElement[] = [
    <Route key="auth" path="/auth" element={<Navigate to="/auth/login" />} />,
    <Route
      key="register-flow"
      path="/register/flow"
      element={<Navigate to="/dashboard" />}
    />,
    <Route
      key="user-account"
      path="/user-account"
      element={<Navigate to="/user-account/profile" />}
    />,
  ];

  if (hasCompanies) {
    returnArray.push(
      <Route key="home" path="/" element={<Navigate to="/energy" />} />,
    );
  } else {
    returnArray.push(
      <Route
        key="home"
        path="/"
        element={<Navigate to="/user-account/profile" />}
      />,
    );
  }

  return returnArray;
};
